import moment from 'moment';

export const calculcateRemainingTrialDays = (endDate: number) => {
  const diff = moment.duration(endDate - Date.now());
  const diffInDays = Math.floor(diff.asDays());
  return `${diffInDays < 0 ? 0 : diffInDays} ${
    diffInDays === 1 ? 'day' : 'days'
  } left in your trial period!`;
};
